import { connect } from 'react-redux'
import { RichStaticSlide } from '@plickers/now-player-library/renderer'
import { isContentAllowed, revisitConsent } from '../../utils/cookieHelpers'

//
// The slide renderer is the shared library's. web's own copy read cookie consent
// from the store; the library cannot, so it takes `youtubeAllowed` as a prop - and
// defaults it to true. This wrapper is the one place web supplies it, so no call
// site can forget it and embed YouTube for a viewer who declined.
//
function mapStateToProps(state) {
  return {
    youtubeAllowed: isContentAllowed('youtube', state.cookieConsents),
    // "manage settings" on the blocked-YouTube overlay; the library cannot reach OneTrust.
    onRevisitConsent: revisitConsent,
  }
}

export default connect(mapStateToProps)(RichStaticSlide)
